import ApiService from "./ApiService";

const AuthorizationService = {
  getAccessToken: async user => await ApiService.post("/get-token/", user),
  sendRecoverLetter: async email =>
    await ApiService.post("/user/password-reset/", { email }),
  resetPassword: async ({ email, token, new_password }) =>
    await ApiService.post("/user/password-reset-confirm/", {
      email,
      token,
      new_password
    }),
  registerFromAppointment: async (password, code) =>
    await ApiService.post(`/appointment-request/${code}/register/`, {
      password
    })
};
export default AuthorizationService;
